import Sprite from './sprite'

export default Sprite